<template>
  <div>
        <el-card class="">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('initializeCommunityManage.queryCondition') }}</div>
          </div>
          <div class="">
            <el-form :inline="true" :model="initializeCommunityManageInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-form-item>
                  <el-input 
                    v-model="initializeCommunityManageInfo.conditions.shopId"
                    :placeholder="$t('initializeCommunityManage.inputCommunityId')">
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="initializeCommunityManageInfo.conditions.name"
                    :placeholder="$t('initializeCommunityManage.inputCommunityName')">
                  </el-input>
                </el-form-item>
                <el-button type="primary" size="small" @click="_queryCommunitys()">
                  <i class="el-icon-search"></i>
                  {{ $t('initializeCommunityManage.query') }}
                </el-button>
                <el-button type="primary" size="small" @click="_resetCommunitys()">
                  <i class="el-icon-refresh"></i>
                  {{ $t('initializeCommunityManage.reset') }}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
        <el-card class="margin-top-sm">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('initializeCommunityManage.initializeCommunityData') }}</div>
          </div>
          <div class="">
            <el-table
              :data="initializeCommunityManageInfo.initializeCommunitys"
              border
              style="width: 100%">
              <el-table-column
                prop="communityId"
                :label="$t('initializeCommunityManage.communityId')"
                align="center">
              </el-table-column>
              <el-table-column
                prop="name"
                :label="$t('initializeCommunityManage.communityName')"
                align="center">
              </el-table-column>
              <el-table-column
                prop="nearbyLandmarks"
                :label="$t('initializeCommunityManage.nearbyLandmark')"
                align="center"
                width="25%">
              </el-table-column>
              <el-table-column
                prop="cityName"
                :label="$t('initializeCommunityManage.cityCode')"
                align="center">
              </el-table-column>
              <el-table-column
                prop="stateName"
                :label="$t('initializeCommunityManage.status')"
                align="center">
              </el-table-column>
              <el-table-column
                :label="$t('initializeCommunityManage.operation')"
                align="center">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="_openChooseinInitializeCommunity(scope.row)">
                    {{ $t('initializeCommunityManage.format') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="total">
            </el-pagination>

            <div class="form-group">
              <li style="color: red;">{{initializeCommunityManageInfo.msgData}}</li>
            </div>
          </div>
        </el-card>

    <choose-initialize-community 
      ref="chooseInitializeCommunity"
      @chooseinitializeCommunity="_initializeCommunity">
    </choose-initialize-community>
  </div>
</template>

<script>
import ChooseInitializeCommunity from '@/components/dev/chooseinitializeCommunity/ChooseInitializeCommunity'
import { listCommunitys, initializeCommunity } from '@/api/dev/initializeCommunityManage/initializeCommunityManageApi'

export default {
  name: 'InitializeCommunityManage',
  components: {
    ChooseInitializeCommunity
  },
  data() {
    return {
      initializeCommunityManageInfo: {
        initializeCommunitys: [],
        total: 0,
        records: 1,
        storeTypeCd: '',
        devPassword: '',
        msgData: '',
        conditions: {
          name: '',
          cityCode: '',
          shopId: ''
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this.storeTypeCd = this.$store.getters.userInfo.storeTypeCd
    console.log(this.storeTypeCd)
    this._listCommunitys(this.currentPage, this.pageSize)
  },
  methods: {
    async _listCommunitys(page, rows) {
      try {
        const params = {
          ...this.initializeCommunityManageInfo.conditions,
          page,
          row: rows
        }
        const res = await listCommunitys(params)
        this.initializeCommunityManageInfo.total = res.total
        this.initializeCommunityManageInfo.records = res.records
        this.initializeCommunityManageInfo.initializeCommunitys = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    async _initializeCommunity(community) {
      try {
        const param = {
          communityId: community.communityId,
          devPassword: community._devPassword
        }
        const res = await initializeCommunity(param)
        if (res.code === 0) {
          this.initializeCommunityManageInfo.msgData = res.data
          this._listCommunitys(this.currentPage, this.pageSize)
          this.$message.success('删除成功')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('请求失败:', error)
        this.$message.error(error)
      }
    },
    _queryCommunitys() {
      this.currentPage = 1
      this._listCommunitys(this.currentPage, this.pageSize)
    },
    _resetCommunitys() {
      this.initializeCommunityManageInfo.conditions.shopId = ""
      this.initializeCommunityManageInfo.conditions.name = ""
      this._listCommunitys(this.currentPage, this.pageSize)
    },
    _openChooseinInitializeCommunity(initializeCommunity) {
      this.$refs.chooseInitializeCommunity.open(initializeCommunity)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listCommunitys(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
</style>